import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLocationAlt = function SvgLocationAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M11.968 1.43c-.282 0-.61 0-.891.047-3.563.375-6.469 3.187-6.984 6.75-.282 2.156.234 4.125 1.359 5.718l5.719 8.203a.98.98 0 00.797.422.98.98 0 00.796-.422l5.766-8.203c.89-1.312 1.453-2.86 1.453-4.547-.047-4.406-3.61-7.968-8.015-7.968zm4.922 11.39l-4.922 6.985-4.922-7.032c-.89-1.265-1.219-2.765-1.032-4.312.375-2.625 2.579-4.781 5.204-5.063.234-.046.468-.046.703-.046 3.281 0 6 2.671 6 6 .047 1.265-.328 2.437-1.031 3.468z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M11.968 5.414a3.981 3.981 0 00-3.985 3.984 3.981 3.981 0 003.985 3.985 3.98 3.98 0 003.984-3.985 3.981 3.981 0 00-3.984-3.984zm0 5.953c-1.078 0-2.016-.89-2.016-2.015a2 2 0 012.016-2.016c1.078 0 2.015.89 2.015 2.016a2 2 0 01-2.015 2.015z"
  }));
};

export default SvgLocationAlt;